<div class="filter-badges-container">
    <ng-container *ngIf="filters && filters.length > 0; else noFilters">
        <span *ngFor="let filter of visibleFilters; let i = index" class="filter-badge"
            [style.background-color]="getFilterColor(i)" [title]="filter">
            {{ filter | status:(this.languageService.default_lang === 'MX' ||
            this.languageService.default_lang === 'SV' ? 'es' :
            this.languageService.default_lang === 'US' ? 'en' : 'es') }}
        </span>
        <span *ngIf="hasMoreFilters" class="toggle-btn" (click)="toggleExpand()">
            {{ expanded ? 'Ver menos' : 'Ver más' }} ({{ filters.length }})
        </span>
    </ng-container>
    <ng-template #noFilters>
        <span class="no-filters">Sin Filtros / No filters</span>
    </ng-template>
</div>